export const MIN_RBAC_LETTER_FIELD_LENGTH = 3;

/** Letters only; optional single spaces between words (e.g. "User Read"). */
export const RBAC_LETTER_FIELD_PATTERN = /^[A-Za-z]+(?: [A-Za-z]+)*$/;

export const sanitizeRbacLetterFieldInput = (value: string): string =>
  value.replace(/[^A-Za-z ]/g, '').replace(/\s{2,}/g, ' ');

export const getRbacLetterFieldError = (value: string, fieldLabel: string): string | null => {
  const trimmed = value.trim();
  if (!trimmed) return null;

  if (!RBAC_LETTER_FIELD_PATTERN.test(trimmed)) {
    return `${fieldLabel} can only contain letters`;
  }

  if (trimmed.length < MIN_RBAC_LETTER_FIELD_LENGTH) {
    return `${fieldLabel} must be at least ${MIN_RBAC_LETTER_FIELD_LENGTH} characters`;
  }

  return null;
};

export const isValidRbacLetterField = (value: string, required = true): boolean => {
  const trimmed = value.trim();
  if (!trimmed) return !required;
  return (
    trimmed.length >= MIN_RBAC_LETTER_FIELD_LENGTH && RBAC_LETTER_FIELD_PATTERN.test(trimmed)
  );
};

export const sanitizeRbacDisplayNameInput = sanitizeRbacLetterFieldInput;

export const getRbacDisplayNameError = (name: string): string | null =>
  getRbacLetterFieldError(name, 'Name');

export const isValidRbacDisplayName = (name: string): boolean => isValidRbacLetterField(name, true);

export const getRbacDescriptionError = (description: string): string | null =>
  getRbacLetterFieldError(description, 'Description');

export const isValidRbacDescription = (description: string): boolean =>
  isValidRbacLetterField(description, false);
